import { render, staticRenderFns } from "./KretanjaPutnogNaloga.vue?vue&type=template&id=9823f0ee&"
import script from "./KretanjaPutnogNaloga.vue?vue&type=script&lang=ts&"
export * from "./KretanjaPutnogNaloga.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports